import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface DashboardState {
  tabDetails: any;
}

const initialState: DashboardState = {
  tabDetails: "",
}

export const dashboardTitle = createSlice({
  name: 'dashboardTitle',
  initialState,
  reducers: {
    setTitle: (state, action: PayloadAction<any>) => {
      state.tabDetails = action.payload
    }
  },
})

export const { setTitle } = dashboardTitle.actions;

export default dashboardTitle.reducer;
